import { ibhApiService } from '@hub/bearing-hub/common/api-service';
import type { IbhIcnArticleLifetimeParams } from '@igus/iglidur-bearing-hub-api';
import * as Sentry from '@sentry/nextjs';

export const fetchIcnArticleLifeTime = async (
  ibhIcnArticleLifetimeParams: IbhIcnArticleLifetimeParams
): Promise<number> => {
  try {
    const response = await ibhApiService.icnArticleLifetime(ibhIcnArticleLifetimeParams);
    return response.data.lifetime;
  } catch (error) {
    Sentry.captureException(error);
    throw new Error(`Cannot fetch lifetime for ICN article number: ${ibhIcnArticleLifetimeParams.articleNumber}`);
  }
};
